import {AjaxManager} from "../../common/ajax";

export function loadProgbar() {
    const pbAreaEl = document.querySelector('.PBArea');
    if (pbAreaEl) {
        const dataset = pbAreaEl.dataset;
        const pollUrl = dataset.pollUrl;

        const pbBarEl = document.querySelector('.PBBar');
        const pbTextEl = document.querySelector('.PBText');

        GlobalEnt.progbar = new ProgBar(pollUrl, pbAreaEl, pbBarEl, pbTextEl, 1, GlobalEnt.objectCallbackMap);
    }
}

export function hasProgbar() {
    return document.querySelector('.PBArea');
}

/**
 Used by the progbar tag.
 Encapsulation of a progress bar which polls the server for progress updates via Ajax.

 This class succeeds the older ProgressMeter class.

 Requires markup like the following:

 <div id="progArea">
 <div id="progBorder"><div id="progBar">&nbsp;</div></div>
 <div id="progTxt">Please wait...</div>
 </div>

 [public methods]
 show()
 hide()
 */
export function ProgBar(pollUrl, progAreaElm, progBarElm, progTxtElm, refreshSeconds) {
    this.pollUrl = pollUrl;
    this.progAreaElm = progAreaElm;
    this.progBarElm = progBarElm;
    this.progTxtElm = progTxtElm;
    this.refreshSeconds = refreshSeconds;

    this.ajaxManager = new AjaxManager();

    this.interval = null;
    this.curReq = null;

    this.showDelay = 2;
    this.hiding = false;
    this.showDelayTimer = null;

    //a callback for progress updates.
    this.updateListeners = [];

    //
    //Methods
    //

    this.show = function(_immediate) {
        let self = this;

        if (!this.hiding) {
            if (_immediate && this.showDelayTimer == null) {
                this.hide();

                this.progBarElm.style.width = "0%";
                this.progAreaElm.style.display = "block";

                if (this.ajaxManager.isSupported() && this.pollUrl != null) {
                    this.interval = setInterval(function(){ self._poll_tick();}, this.refreshSeconds * 1000);
                }
            } else {
                this.showDelayTimer = setTimeout(function(){self._delayed_show();}, this.showDelay * 1000);
            }
        }
    }

    this.hide = function() {
        this.hiding = true;

        if (this.interval != null) {
            clearInterval(this.interval);
            this.interval = null;
        }

        if (this.showDelayTimer != null) {
            clearTimeout(this.showDelayTimer);
            this.showDelayTimer = null;
        }
        this.waitToShow = true;

        if (this.progAreaElm)
            this.progAreaElm.style.display = "none";

        this.hiding = false;
    }

    this.isShowing = function() {
        return this.progAreaElm.style.display == "block";
    }

    this._poll_tick = function() {
        if (this.curReq == null) {
            this.curReq = this.ajaxManager.createRequest();
            if (this.curReq != null) {
                let self = this;
                this.curReq.onreadystatechange = function() {self._ajax_callback();};
                this.curReq.open("GET", this.pollUrl);
                // safari caching workaround -
                // explicitly set to discard cached files newer than this...
                this.curReq.setRequestHeader('If-Modified-Since', 'Wed, 15 Nov 1995 00:00:00 GMT');
                this.curReq.send(null);
            }
        }
    }

    this._ajax_callback = function() {
        if (this.curReq.readyState == 4) {
            if (this.curReq.status == 200) {
                let progRes = new ProgressResponse(this.curReq.responseText);
                let progStr = progRes.toString();
                if (progStr != null) {
                    this.setProgress(progRes.getPercent(), progStr);

                    //Notify listeners of progress change
                    for (let i = 0; i < this.updateListeners.length; i++)
                        this.updateListeners[i](progRes.getPercent());
                }
            }

            this.curReq = null;
        }
    }

    this._delayed_show = function() {
        this.showDelayTimer = null;
        this.show(true);
    }

    /**Listen to updates in progress.
     Your callback function will be given one argument: an integer from 0 to 100*/
    this.addUpdateListener = function(callback_func) {
        this.updateListeners.push(callback_func);
    }

    this.setProgress = function(integerPercent, message) {
        this.progTxtElm.firstChild.nodeValue = message;
        this.progBarElm.style.width = integerPercent + "%";
    }
}

/**
 Parser object for progress responses.  Use by ListPageLogic.
 [public methods]
 toString()
 getPercent()
 */
export function ProgressResponse(responseTxt) {
    this.percent_complete = 0.0;
    this.progressStr = null;

    //The new-style abitrary message progress: "%34.7\nRestoring Database 34%"
    if (responseTxt.charAt(0) == '%') {
        let lines = responseTxt.split("\n");
        if (lines.length == 2) {
            //First line is percentage complete
            let percent = parseFloat(lines[0].substring(1));
            if (isNaN(percent))
                percent = 0.0;
            else if (percent < 0.0)
                percent = 0.0;
            else if (percent > 100.0)
                percent = 100.0;

            this.percent_complete = percent;

            this.progressStr = lines[1];
        }
    }
    //Assume Original format:  "34/100"
    else {
        let parts = responseTxt.split("/");
        if (parts.length == 2 && parts[0].length > 0 && parts[1].length > 0) {
            let nDone = parseInt(parts[0], 10);
            let nTotal = parseInt(parts[1], 10);
            if (!isNaN(nDone) && !isNaN(nTotal)) {
                this.progressStr = nDone + " of " + nTotal;  //TODO: i18n
                this.percent_complete = (nDone / nTotal) * 100.0;
            }
        }
    }

    this.toString = function() {
        return this.progressStr;
    }

    this.getPercent = function() {
        //caller expects integer from 0-100
        return Math.round(this.percent_complete);
    }
}